import AlertModal from "components/AlertModal/AlertModal";
import React from "react";
import "./RedirectToMobileScreen.css";
import StateLogo from "assets/icons/Fabpiks.png";
import GooglePlayStoreLogo from "assets/icons/playstore.svg";
import IosPlayStoreLogo from "assets/icons/apple.svg";
function openNewTab(url) {
  window.open(url);
}
function RedirectToMobileScreen({ errorMessages }) {
  return (
    <>
      <div className="main-content-redirect">
        <div className="company-logo">
          <img src={StateLogo} />
        </div>
        <div className="download-text">
          Please download the Fabpiks App to scan the code & use the vending
          machine
        </div>{" "}
      </div>
      <div className="sub-content">
        <div className="redirect-hint-text-1">For Android Users</div>
        <div
          className="mobile-btn-redirect"
          onClick={() => openNewTab("https://play.google.com/store/apps/details?id=com.fabpiks.fabpiks&hl=en_IN&gl=US")}
        >
          Google Play{" "}
          <img className="google-play-image" src={GooglePlayStoreLogo} />
        </div>
        <div className="redirect-hint-text-2">For IOS Users</div>
        <div
          className="mobile-btn-redirect"
          onClick={() => openNewTab("https://apps.apple.com/in/app/fabpiks-samples-deals/id6447238261")}
        >
          Apple Store <img className="ios-play-image" src={IosPlayStoreLogo} />
        </div>
      </div>
    </>
  );
}

export default RedirectToMobileScreen;
